module.exports = __webpack_public_path__ + "img/shutterstock_1940399131-768x505.bc8a5c7e.jpg";